import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import type { AdminProfile, AdminProfileForm } from '@/types'
import apiClient from '@/lib/api/client'
import { getAdminProfile as sdkGetAdminProfile, updateAdminProfile as sdkUpdateAdminProfile } from '@/lib/api/generated/sdk.gen'

// 获取管理员配置
export const useAdminProfile = () => {
  return useQuery({
    queryKey: ['admin-profile'],
    queryFn: async (): Promise<AdminProfile> => {
      const res: any = await sdkGetAdminProfile({ 
        client: apiClient, 
        responseStyle: 'fields', 
        throwOnError: false 
      })
      return ((res as any)?.data ?? res) as AdminProfile
    },
  })
}

// 更新管理员配置
export const useUpdateAdminProfile = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: AdminProfileForm): Promise<AdminProfile> => {
      const res: any = await sdkUpdateAdminProfile({ 
        client: apiClient, 
        responseStyle: 'fields', 
        throwOnError: false, 
        body: data as any 
      })
      return ((res as any)?.data ?? res) as AdminProfile
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-profile'] })
    },
  })
}
